import Container from '@/containers';

const indexRouter = {
    path: '/',
    component: Container, 
    name: 'index',
    meta: {
        title: '首页'
    },
    children: [
        {
            path: '/',
            component: () => import('@/views/dashboard'),
            name: 'Index',
            meta: {
                title: '首页'
            }
        }
    ]
};

export default indexRouter;